import { createRouter, createWebHistory } from 'vue-router'

import { generateRoutes } from '@/extensions/langRouter'

const NotFound = () => import('@/views/NotFound.vue')

const routes = [
  {
    path: '/',
    paths: { en: '/' },
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/a-propos',
    paths: { en: '/about' },
    name: 'about',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/activites',
    paths: { en: '/activities' },
    name: 'activities',
    component: () => import('@/views/Activities.vue'),
  },
  {
    path: '/activite/:slug',
    paths: { en: '/activity/:slug' },
    name: 'activity',
    component: () => import('@/views/Activity.vue'),
  },
  {
    path: '/volet/:slug',
    paths: { en: '/category/:slug' },
    name: 'category',
    component: () => import('@/views/Category.vue'),
  },
  {
    path: '/politique-de-confidentialite',
    paths: { en: '/privacy-policy' },
    name: 'policies',
    component: () => import('@/views/Policies.vue'),
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: NotFound,
  },
]

const localizedRoutes = generateRoutes(routes, 'fr', ['en'])

export default createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes,
  scrollBehavior(to) {
    return to.hash
      ? { el: to.hash, behavior: 'smooth', top: window.innerWidth < 1025 ? 72 : 100 }
      : { top: 0 }
  },
})
